
import './App.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap";
import 'bootstrap/dist/js/bootstrap.bundle';
import NavBar from './Components/Navbar';
import Home from './Components/Home';
import Footer from './Components/Footer';
import InterfacialPhenomenaAndNanoconfinement from './Components/Research/InterfacialPhenomenaAndNanoconfinement';
import ComputationalDrugDesign from './Components/Research/ComputationalDrugDesign';
import MachineLearning from './Components/Research/MachineLearning';
import RefereedJournal from './Components/Publications/RefereedJournal';
import Books from './Components/Publications/Books';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import Conference from './Components/Publications/Conference';
import CurrentMembers from './Components/People/CurrentMembers';
import Collaborators from './Components/People/Collaborators';
import Alumni from './Components/People/FormerMembers';
import Resources from './Components/Resources';
import Fundings from './Components/Fundings';
import Nucleation from './Components/Research/Nucleation';
import Details from './Components/Details';
import JoinUs from './Components/JoinUs';
import GroupPhotos from './Components/People/GroupPhotos';

function App() {
  return (
    <BrowserRouter>
    <div className='d-flex flex-column min-vh-100'>
    <NavBar/>
      <Routes>
          <Route path="/~atanu.metya/" element={<Home/>} />
          <Route path="/~atanu.metya/research/interfacialPhenomenaAndNanoconfinement" element={<InterfacialPhenomenaAndNanoconfinement />} />
          <Route path="/~atanu.metya/research/nucleation" element={<Nucleation />} />
          <Route path="/~atanu.metya/research/computationalDrugDesign" element={<ComputationalDrugDesign />} />
          <Route path="/~atanu.metya/research/machineLearning" element={<MachineLearning />} />
          <Route path="/~atanu.metya/publications/refereedJournal" element={<RefereedJournal />} />
          <Route path="/~atanu.metya/publications/books" element={<Books />} />
          <Route path="/~atanu.metya/publications/conference" element={<Conference />} />
          <Route path="/~atanu.metya/people/currentMembers" element={<CurrentMembers />} />
          <Route path="/~atanu.metya/people/collaborators" element={<Collaborators />} />
          <Route path="/~atanu.metya/people/formerMembers" element={<Alumni />} />
          <Route path="/~atanu.metya/people/groupPhotos" element={<GroupPhotos />} />
          <Route path="/~atanu.metya/resources" element={<Resources />} />
          <Route path="/~atanu.metya/fundings" element={<Fundings />} />
          <Route path="/~atanu.metya/details" element={<Details />} />
          <Route path="/~atanu.metya/joinUs" element={<JoinUs />} />
      </Routes>
    <Footer/>
    </div>
    </BrowserRouter>
  );
}

export default App;
